<template>
  <div
    class="relative w-full overflow-hidden rounded-lg"
    :style="{ aspectRatio: ratio }"
  >
    <!-- Skeleton Placeholder -->
    <div
      v-if="!isLoaded"
      class="absolute inset-0 bg-gray-100 animate-pulse rounded-lg z-0"
    ></div>

    <!-- Nuxt Image -->
    <nuxt-img
      ref="imageRef"
      :src="imageSrc"
      alt="image-card"
      format="webp"
      class="absolute inset-0 object-cover w-full h-full transition-opacity duration-300 rounded-lg z-10"
      :class="{ 'opacity-0': !isLoaded, 'opacity-100': isLoaded }, imageClasses"
      @load="handleImageLoad"
    />

    <!-- Optional Overlay -->
    <div
      v-if="overlay"
      class="absolute inset-0 bg-black/30 rounded-lg z-20"
    ></div>

    <!-- Slot content shown only when image is loaded -->
    <slot v-if="isLoaded"></slot>
  </div>
</template>

<script setup>
const props = defineProps({
  imageSrc: {
    type: String,
    required: true,
  },
  overlay: {
    type: Boolean,
    default: false,
  },
  ratio: {
    type: String,
    default: "4 / 3",
  },
  imageClasses: {
    type:String,
    default: ''
  }
});

const isLoaded = ref(false);
const imageRef = ref(null);

const handleImageLoad = () => {
  isLoaded.value = true;
};

onMounted(async () => {
  await nextTick();
  const imgEl = imageRef.value?.$el;
  if (imgEl?.complete) {
    isLoaded.value = true;
  }
});
</script>
